//chapter1
export default {
    id : 10,//chapter number
    title : '10. DFMEA 작성방법 (3) - DFMEA 기능분석과 특성',//chapter name
    slides : [
        {
            title : 'Intro',
            type : 'intro',
            source : 'c10.mp4',
        },
        {
            title : 'Today’s Goal',
            type : 'plan',
            body1 : [
                'DFMEA 기능분석과 특성',
            ],
            body2 : [
                'DFMEA 기능분석과 특성에 대해 설명할 수 있다.'
            ],
            bgm : "plan.mp3"
        },
        {
            title : 'Lesson',
            type : 'lesson',
            source : '10.mp4',
        },
        {
            title : 'Quiz',
            type : 'quiz',
            quiz : [
                {
                    type : 'ox',
                    question : '기능의 정의는 고장형태를 정의하는데 도움을 준다.',//html available
                    answer : "1",
                    explain : '고장은 요구기능의 불만족 형태이다.'
                },
                {
                    type : 'ox',
                    question : 'P-Diagram은 기능에 영향을 주는 매개변수의 해석이다.',//html available
                    answer : "1",
                    explain : '전체적인 매개변수의 해석도구이다.'
                },
            ],
            quizMask : "../assets/images/quiz_intro.jpg",//quiz mask
            bgm : "quiz.mp3"
        },
        {
            title : 'Summary',
            type : 'summary',
            /*download : 'sample.pptx',//data folder*/
            print : false,// true : show, false: hide
            slides : [
                {
                    body : `<ul>
                        <h3>1. 기능분석의 목적</h3>
                        <li>시스템 element에 요구사항/스펙에 의해 규정된 기능이 적절하게 할당됨을 보증하는 것임</li>
                        <li>DFMEA를 작성하는데 사용되는 TOOL에 상관없이 기능의 형태로 작성된 분석은 중요함</li>
                        <p class="mg10"></p>
                        <h3>2. P-Diagram 작성방법</h3>
                        <p class="mg10"></p>
                        <h3>3. Effect - Failure Mode - Cause의 구조</h3>
                        <p class="mg10"></p>
                        <h3>4. 양식 사용방법</h3>
                    </ul>`
                },
            ],
            bgm : "summary.mp3"
        },
        {
            title : 'Outro',
            type : 'outro',
            source : 'c10.mp4',
        },
    ]
}